export default __webpack_public_path__ + "static/media/notifiylogo.172d26ee.svg";